export class UsageStatistics {
    UserId: string;
    CompanyId: string;
    Page: string;
    RemoteAddress: string;
}